
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/page/[slug]",
      function () {
        return require("private-next-pages/[market]/[language]/page/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/page/[slug]"])
      });
    }
  